<template>
  <div v-if="activePayment == id" class="col-24 mt-lg-1 order-lg-1 payment_method_item">
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activePayment: "checkoutPayment/getActivePayment",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.fade-enter-active {
  transition-property: opacity, transform;
  transition-duration: $transition-duration;
  transition-delay: $transition-duration-short;
}

.fade-leave-active {
  transition-property: opacity, transform;
  transition-delay: $transition-duration-short;
  transition-duration: $transition-duration;
  transform: translateY(-$spacer / 2);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY($spacer / 2);
  position: absolute;
}

.fade-enter-to,
.fade-leave {
  position: relative;
}
</style>
